import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, LabelList } from 'recharts';

const data = [
  { date: '8 Oct', Hora: 4 },
  { date: '9 Oct', Hora: 0.5 },
  { date: '10 Oct', Hora: 3 },
  { date: '11 Oct', Hora: 4 },
  { date: '12 Oct', Hora: 2.30 },
  { date: '13 Oct', Hora: 3.40 },
  { date: '14 Oct', Hora: 1 },
];

//Redondeo a la barra
const RoundedRectangle = (props) => {
  const { x, y, width, height, fill } = props;
  return (
    <path
      d={`M${x},${y} 
          H${x + width - 10} 
          Q${x + width},${y} ${x + width},${y + 10} 
          V${y + height - 10} 
          Q${x + width},${y + height} ${x + width - 10},${y + height} 
          H${x} 
          V${y} Z`}
      fill={fill}
    />
  );
};

const FrequencyChart = () => {
  return (
    <div className="p-4 bg-white rounded-[16px] shadow-[0px_5px_20px_rgba(0,0,0,0.3)] ">
      <h2 className="text-[20px] mb-4 font-itcmedium text-[#007696]">Frecuencia de Pesaje</h2>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} layout="vertical">
          <CartesianGrid stroke="none" />
          <XAxis type="number" axisLine={false} tickLine={false} tick={false}  />
          <YAxis dataKey="date"
            type="category"
            axisLine={{ stroke: '#76A140', strokeWidth: 2 }}
            tickLine={{ stroke: '#76A140', strokeWidth: 2 }} 
            tick={{ fill: '#52526C', fontSize: 12 }}
            />
          <Tooltip />
          <Bar dataKey="Hora" fill="#5CBDEB80" shape={<RoundedRectangle />}>
            <LabelList
              dataKey="Hora"
              position="insideEnd" 
              fill="#52526C" 
              fontSize={14}
              content={({ x, y, width, value }) => {
                const height = 20; 
                const text = value >= 1 ? `${value} horas` : `${(value * 60).toFixed(0)} min`;
                const isSmall = value < 1; // Si la barra es menor a 1 hora
                const textX = isSmall ? x + width + 5 : x + width - 5; // Mover fuera si la barra es pequeña
                const textY = y + height / 1.5; 
                return (
                  <text
                    x={textX} 
                    y={textY} 
                    fill="#52526C" 
                    fontSize={12}
                    textAnchor={isSmall ? "start" : "end"} // Alinea el texto fuera si es pequeño
                    alignmentBaseline="middle" 
                  >
                    {text}
                  </text>
                );
              }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
export default FrequencyChart;
